export default "__VITE_ASSET__CcFJbe38__"